export default __webpack_public_path__ + "static/media/google.a4f91c1f.svg";